module.exports = __webpack_public_path__ + "img/753f39f5f61f4f78841a7b85458b5d51_mergeImage.2db4ac33.png";